import React, { useState, useMemo, useCallback } from 'react'
import OrderlikeLayout from '../../../../generic/Layouts/OrderlikeLayout'
import ControlSearchPannelLayout from '../../../../generic/Layouts/Wrappers/ControlSearchPannelLayout'
import SearchInput from '../../../../generic/inputs/inputSearch'
import DatePickerISO from '../forcasts/Distribution/Components/DatePickerISO'
import BodyScrollContainer from '../../../../generic/Layouts/Wrappers/BodyScrollContainer'
import ControlButton from '../../../../generic/buttons/ControlButton'
import { useNavigate } from 'react-router-dom'
import { LINKS } from '../../../../Routs/config'
import { useProblemStateManager } from './context/ProblemStateManager'
import { IProblemWithDetailsNew, ICreateProblemData, ICreateProblemLine, IProblemLineNew } from '../../../../modules/API/TeudotProblems/models/problems'
import ProblemHandleModal from '../drivers/modals/ProblemHandleModal'
import { ISelectedProblem } from '../drivers/DriversMain'
import { IOrderItem } from '../../../../modules/API/Drivers/models/kavData'
import ProblemWithDetailsItem from './Components/ProblemWithDetailsItem'
import TitlesList from '../../../../generic/titlesRowItem/TitlesList'
import useDataFetcher from '../knisot/hooks/useFetchData'
import { TEUDOT_PROBLEMS } from '../../../../modules/API/TeudotProblems/teudotProblems'
import { calcPrevDateRange } from './helpers/dateUtils'
import ColumModal from '../../../../generic/Layouts/ColumModal'
import ProblemModal from './Components/ProblemModal'
import { ISelectedProduct } from './types/problemModal'
import { handleNotifications } from '../../../../generic/utils/handleNotifications'
import { useProblemTypes } from './hooks/useProblemTypes'
import { useSelector } from 'react-redux'
import { RootState } from '../../../../../store/reducers/rootReducer'
import { IClientsItem } from '../../../../modules/API/Defaults/models/customers'
import DropdownByIcon from '../azmanotRehesh/Layouts/DropdownByIcon'
import FilterIcon from '../../../../generic/icons/IconLib/FilterIcon'
import FilterProblemMain from './Components/FilterProblemMain'
import SignatureCanvas from '../../../../generic/Signature/SignatureCanvas'
import DatePickerRangeISO from '../knisotLines/Components/DatePickerRangeISO'
import { IApproveProblemBulkData, IApproveProblemData } from '../../../../modules/API/TeudotProblems/models/requests'
import { format } from 'date-fns'
import SearchProblem from './Components/SearchProblem'
import { Defaults } from '../../../../modules/API/Defaults/defaults'
import { ISellerResponse } from '../../../../modules/API/Defaults/models/seller'
import { useProblemHelpers } from './hooks/useProblemHelpers'
import CustomBlockLoader from '../knisot/generic/CustomBlockLoader'

const ProblemTeudotMain = () => {
  const navigate = useNavigate()
  const [search, setSearch] = useState('')
  // const [selectedDates, setSelectedDates] = useState<Date[]>([new Date(), new Date()])
  const [selectedCustomerID, setSelectedCustomerID] = useState<number>(0)
  const [selectedProblemType, setSelectedProblemType] = useState<number>(0)
  const [selectedProblemStatus, setSelectedProblemStatus] = useState<number>(0)
  const [selectedSeller, setSelectedSeller] = useState<number>(0)
  const [isOpenModal, setIsOpenModal] = useState(false)
  const [selectedProduct, setSelectedProduct] = useState<ISelectedProduct | null>(null)
  const [isSubmitting, setIsSubmitting] = useState(false)
  const [, setSignatureData] = useState<string | null>(null)
  const [isOpenDriverStatusModal, setIsOpenDriverStatusModal] = useState(false)
  const [selectedDriverProblem, setSelectedDriverProblem] = useState<ISelectedProblem | null>(null)
  const { date, setDate, isAllowToApprove, user } = useProblemStateManager()
  const isOfficeUser = useMemo(() => {
    return user?.rights.includes('OFFICE')
  }, [user?.rights])
  // Load customer list from Redux
  const customerList: IClientsItem[] = useSelector((state: RootState) => state.defaults?.clientList?.list || [])

  // Load problem types when component mounts
  const { problemTypes } = useProblemTypes()

  const formatedString = useMemo(() => {
    if (date[0] && date[1]) {
      return `DateFrom=${format(date[0], 'yyyyMMdd')}&DateTo=${format(date[1], 'yyyyMMdd')}`
    }
    return ''
  }, [date])

  const {
    data: problemsWithDetailsNew,
    isLoading: isLoadingProblems,
    setData: setProblemsData
  } = useDataFetcher<IProblemWithDetailsNew[]>(
    TEUDOT_PROBLEMS.getProblemsByDateRange,
    formatedString
  )

  const {
    data: sellerList,
    isLoading: isLoadingSeller,
    setData: setSellerList
  } = useDataFetcher<ISellerResponse>(
    Defaults.getSellerList,
    "data"
  )
  // Filter customer list to only include customers that exist in problemsWithDetailsNew
  const filteredCustomerList = useMemo(() => {
    if (!problemsWithDetailsNew || !customerList) return []
    
    // Get unique customer IDs from problems
    const problemCustomerIds = new Set(problemsWithDetailsNew.map(problem => problem.CustomerID))
    
    // Filter customers to only include those with IDs existing in problems
    return customerList.filter(customer => problemCustomerIds.has(customer.CustomerID))
  }, [problemsWithDetailsNew, customerList])


  const filteredSellerList = useMemo(() => {
    if (!problemsWithDetailsNew || !sellerList) return []
    const problemSellerIds = new Set(problemsWithDetailsNew.map(problem => problem.SellerID))
    return sellerList.sellers.filter(seller => problemSellerIds.has(seller.SellerID))
  }, [problemsWithDetailsNew, sellerList])

  const problemList = useMemo(() => {
    if (!problemsWithDetailsNew) return []
    const problemSet = new Set()
    problemsWithDetailsNew.forEach(problem => {
      problem.ProblemLines.forEach(line => {
        problemSet.add(line.ProblemType)
      })
    })

    const defaultProblemList = problemTypes?.filter(type => problemSet.has(type.Code)) || []
    return defaultProblemList
  }, [problemsWithDetailsNew, problemTypes])

  const filteredProblems = useMemo(() => {
    if (!problemsWithDetailsNew) return []
    return problemsWithDetailsNew.filter((problem) => {
      const searchLower = search.toLowerCase()
      const matchesSearch = (
        problem.RecID.toString().includes(searchLower) ||
        problem.Delivery_Num.toString().includes(searchLower) ||
        problem.FullDescription.toLowerCase().includes(searchLower) ||
        problem.Remark?.toLowerCase().includes(searchLower) ||
        problem.Customer_Name?.toLowerCase().includes(searchLower) ||
        problem.Seller_Desc?.toLowerCase().includes(searchLower)
      )
      const matchesSeller = selectedSeller === 0 || problem.SellerID === selectedSeller
      const matchesProblemStatus = problem.ProblemLines.some(line => line.Status === selectedProblemStatus)
      console.log(matchesProblemStatus)
      // Filter by selected customer if one is selected
      const matchesCustomer = selectedCustomerID === 0 || problem.CustomerID === selectedCustomerID
      const matchesProblemType = selectedProblemType === 0 || problem.ProblemLines.some(line => line.ProblemType === selectedProblemType)
      return matchesSearch && matchesCustomer && matchesProblemType && matchesProblemStatus && matchesSeller
    })
  }, [problemsWithDetailsNew, search, selectedCustomerID, selectedProblemType, selectedProblemStatus, selectedSeller])

  // Check if customer filter is active
  const isCustomerFilterActive = useMemo(() => {
    return selectedCustomerID !== 0 || 
            selectedSeller !== 0 ||
            selectedProblemType !== 0 ||
            selectedProblemStatus !== 0
  }, [selectedCustomerID, selectedSeller, selectedProblemType, selectedProblemStatus])

  const handleControlModal = useCallback(() => {
    setIsOpenModal(!isOpenModal)
  }, [isOpenModal])

  const handleSelectProblem = useCallback((problem: IProblemWithDetailsNew) => {
    // Transform IProblemWithDetailsNew to ISelectedProduct format
    const selectedItem: ISelectedProduct = {
      // IPalletDetailes fields (provide values from problem where possible, otherwise safe defaults)
      GeneralProductID: problem.GeneralProductID,
      BuyPrice: 0,
      CheckComment: "",
      Customer_Name: problem.Customer_Name || "",
      Delivery_Date: problem.Delivery_Date || "",
      Delivery_Num: problem.Delivery_Num || 0,
      Delivery_Sub: problem.Delivery_Sub || 0,
      GrowerName: "",
      InvoiceBuy: 0,
      InvoiceSale: 0,
      OrderLineRef: 0,
      PackID: 0,
      Pack_Name: "",
      Pallet_Num: 0,
      Pallet_Type: 0,
      Pallete_Desc: "",
      ProductDesc: problem.FullDescription || "",
      QualityDesc: "",
      Quantity: 0,
      Quantity_Pallets: 0,
      RecID: problem.PalletDetailRecID || 0,
      SalePrice: 0,
      SizeID: "",
      Type_BuyCalculation: 0,
      Type_SaleCalculation: 0,
      VarietyDesc: "",
      WeightBuy: 0,
      WeightNeto: 0,

      // Additional fields required by ISelectedProduct
      PalletDetailsRecID: problem.PalletDetailRecID,
      RemarkApproved: "",
      RemarkRequested: problem.Remark || "",
      Problems: problem.ProblemLines.map(line => ({
        RecID: line.RecID,
        TitleRecID: line.TitleRecID,
        ProblemType: Number(line.ProblemType),
        Weight: Number(line.Weight),
        Price: line.Price,
        Status: line.Status,
        LastUser: line.LastUser,
        RemarkApproved: line.RemarkApproved,
        RemarkRequested: line.RemarkRequested,
        QuantityRequested: line.QuantityRequested,
        WeightRequested: line.WeightRequested,
        PriceRequested: line.PriceRequested,
        QuantityApproved: line.QuantityApproved,
        WeightApproved: line.WeightApproved,
        PriceApproved: line.PriceApproved,
        Quantity: line.Quantity,
        DriverStatus: line.DriverStatus,
        DriverWorkerID: line.DriverWorkerID,
        ApprovedBy: line.ApprovedBy,
        CreatedBy: line.CreatedBy,
        PriceOriginal: line.PriceOriginal,
        WeightOriginal: line.WeightOriginal,
        QuantityOriginal: line.QuantityOriginal,
      }))
    }
    
    setSelectedProduct(selectedItem)
    handleControlModal()
  }, [handleControlModal])

  const handleSubmitProblem = useCallback(async (data: { generalRemark: string; problems: Omit<ICreateProblemLine, 'id'>[] }) => {
    if (!selectedProduct) return
    
    setIsSubmitting(true)
    
    try {
      const createData: ICreateProblemData = {
        PalletDetailRecID: selectedProduct.PalletDetailsRecID,
        Remark: data.generalRemark,
        Problems: data.problems
      }

      const updatedProblem = await TEUDOT_PROBLEMS.createProblem(createData)
      
      // Update the specific problem in the list instead of refetching all data
      if (problemsWithDetailsNew && updatedProblem) {
        const updatedProblems = problemsWithDetailsNew.map(problem => 
          problem.PalletDetailRecID === selectedProduct.PalletDetailsRecID 
            ? updatedProblem 
            : problem
        )
        setProblemsData(updatedProblems)
      }
      
      handleControlModal()
      handleNotifications("פניהעודכנה בהצלחה", {type: "success"})
    } catch (error) {
      handleNotifications("אירעה שגיאה בעת עדכון הבעיה", {type: "error"})
    } finally {
      setIsSubmitting(false)
    }
  }, [selectedProduct, handleControlModal, problemsWithDetailsNew, setProblemsData])

  const handleApproveProblem = useCallback(async (topRecID: number, data: IApproveProblemData) => {
    if (!isAllowToApprove) return
    try {
      await TEUDOT_PROBLEMS.approveProblem(data)
      // Update the specific problem in the list instead of refetching all data
      if (problemsWithDetailsNew) {
        console.log(data)
        const newData = [...problemsWithDetailsNew]
        const updatedProblems = newData.map(problem => {
          if(problem.RecID === topRecID) {
            
            return { ...problem, ProblemLines: problem.ProblemLines.map(line => line.RecID === data.RecID ? { ...line, ...data} : line) }
          }
          return problem
        }
        )
        setProblemsData(updatedProblems)      
      }

    } catch (error) {
      handleNotifications("אירעה שגיאה בעת עדכון הבעיה", {type: "error"})
    }
  }, [isAllowToApprove, problemsWithDetailsNew, setProblemsData])

  const handleBulkApproveProblems = useCallback(async (data: IApproveProblemBulkData) => {
    if (!isAllowToApprove) return
    try {
      const res = await TEUDOT_PROBLEMS.bulkApproveProblems(data)
      
      // Update the specific problem in the list instead of refetching all data
      if (problemsWithDetailsNew) {
        const updatedProblems = [...problemsWithDetailsNew].map(problem => {
          if(res.RecID === problem.RecID) {
            return {...res}
          }
          return problem
        })
        console.log(updatedProblems)
        setProblemsData(updatedProblems)
      }
    } catch (error) {
      handleNotifications("אירעה שגיאה בעת עדכון הבעיה", {type: "error"})
    }
  }, [isAllowToApprove, problemsWithDetailsNew, setProblemsData])
  const handleCreate = () => {
    navigate(LINKS.teudotProblems.list.create)
  }

  const handleOpenDriverStatusModal = useCallback((line: IProblemLineNew, parent: IProblemWithDetailsNew) => {
    if (!isOfficeUser) return
    const orderItem: IOrderItem = {
      Collect_Comm: "",
      CustomerID: parent.CustomerID,
      Customer_Name: parent.Customer_Name || "",
      Delivery_Code: 0,
      Delivery_Date: parent.Delivery_Date || "",
      Delivery_Num: parent.Delivery_Num || 0,
      Delivery_Sub: parent.Delivery_Sub || 0,
      DeliveryStat: 0,
      DistributNote: "",
      DriverStatus: line.DriverStatus,
      GroupDesc: "",
      GroupID: 0,
      OrderID: line.RecID,
      Packs: line.Quantity,
      Pallets: 0,
      PickupGroup: 0,
      PickupOrder: 0,
      Reg_Date: "",
      Remarks: "",
      ResellerID: 0,
      Status: line.Status,
      To_PickupTime: "",
      TransferZone: 0,
      Order_Type: 0,
      ProductDesc: parent.FullDescription || "",
      ProductID: parent.GeneralProductID,
      VarietyDesc: "",
      VarietyID: 0,
      Type: 0,
      Weight: line.Weight,
      WorkerID: 0,
      PalletsList: [],
      Distr_Order: 0,
      LastAction: { Action: 0, ActionDescription: "", ActionFlag: false, LogDate: "", LogTime: "" },
    }
    setSelectedDriverProblem({
      kavID: 0,
      CustomerID: parent.CustomerID,
      item: [orderItem],
    })
    setIsOpenDriverStatusModal(true)
  }, [isOfficeUser])

  const handleCloseDriverStatusModal = useCallback(() => {
    setIsOpenDriverStatusModal(false)
    setSelectedDriverProblem(null)
  }, [])

  const handleDriverStatusChange = useCallback(async (problemRecID: number, status: number) => {
    if (!isOfficeUser) return
    try {
      await TEUDOT_PROBLEMS.approveProblemForDriver(problemRecID, status, true)
      if (problemsWithDetailsNew) {
        const updatedProblems = problemsWithDetailsNew.map(problem => ({
          ...problem,
          ProblemLines: problem.ProblemLines.map(line =>
            line.RecID === problemRecID ? { ...line, DriverStatus: status } : line
          )
        }))
        setProblemsData(updatedProblems)
      }
      setSelectedDriverProblem(prev => prev ? {
        ...prev,
        item: prev.item.map(it => it.OrderID === problemRecID ? { ...it, DriverStatus: status } : it)
      } : prev)
      handleNotifications("הסטטוס עודכן בהצלחה", { type: "success" })
    } catch (error) {
      handleNotifications("אירעה שגיאה בעת עדכון הסטטוס", { type: "error" })
    }
  }, [isOfficeUser, problemsWithDetailsNew, setProblemsData])

  const handleDeleteProblem = useCallback(async (recId: number) => {
    if (!isAllowToApprove) return
    try {
      await TEUDOT_PROBLEMS.deleteProblem(recId)
      
      // Remove the deleted problem from the list
      if (problemsWithDetailsNew) {
        const updatedProblems = problemsWithDetailsNew.filter(problem => problem.RecID !== recId)
        setProblemsData(updatedProblems)
      }
      
      handleNotifications("פניה נמחקה בהצלחה", {type: "success"})
    } catch (error) {
      handleNotifications("אירעה שגיאה בעת מחיקת הפניה", {type: "error"})
    }
  }, [isAllowToApprove, problemsWithDetailsNew, setProblemsData])

  // Signature handlers
  // const handleSignatureChange = useCallback((signature: string | null) => {
  //   setSignatureData(signature)
  //   console.log('signature', signature) 
  //   if (signature) {
  //     console.log('✅ Signature captured successfully!')
  //     handleNotifications("חתימה נשמרה בהצלחה", {type: "success"})
  //   } else {
  //     console.log('🗑️ Signature cleared')
  //     handleNotifications("חתימה נמחקה", {type: "success"})
  //   }
  // }, [])

  // const handleSignatureStart = useCallback(() => {
  //   console.log('🖊️ Started drawing signature')
  // }, [])

  // const handleSignatureEnd = useCallback(() => {
  //   console.log('🛑 Finished drawing signature')
  // }, [])

  const additionalItemProps = {
    handleSelectProblem,
    handleDeleteProblem,
    handleApproveProblem,
    isAllowToApprove,
    handleBulkApproveProblems,
    isOfficeUser: isOfficeUser,
    handleOpenDriverStatusModal,
  }

  const driverStatusModalProps = {
    handleProblem: handleDriverStatusChange,
    selectedProblem: selectedDriverProblem as ISelectedProblem,
  }

  const additionalModalProps = {
    selectedProduct,
    onSubmit: handleSubmitProblem,
    isLoading: isSubmitting,
    problemTypes
  }
  

  return (
    <OrderlikeLayout
      label="זיכוים והחזרות"
    >
      {isOpenModal && (
        <ColumModal
          controlFunc={handleControlModal}
          title={`${selectedProduct?.ProductDesc.trim()} ${selectedProduct?.VarietyDesc.trim()} ${selectedProduct?.SizeID.trim()}`}
          childrenProps={additionalModalProps}
          Children={ProblemModal}
        />
      )}
      {isOpenDriverStatusModal && selectedDriverProblem && (
        <ColumModal
          controlFunc={handleCloseDriverStatusModal}
          title="איסוף החזרה"
          childrenProps={driverStatusModalProps}
          Children={ProblemHandleModal}
        />
      )}
      <ControlSearchPannelLayout>
        <DatePickerRangeISO 
          selectedDates={date}
          onChange={setDate}
        />
        {/* <DatePickerISO
          selected={date}
          onChange={setDate}
        /> */}
        <SearchInput 
          input={search}
          setInput={setSearch}
        />
        {
          filteredCustomerList.length > 0 && (
            <DropdownByIcon
              icon={<FilterIcon />}
              isSelected={isCustomerFilterActive}
              isOreintaionRight
            >
              <FilterProblemMain
                selectedCustomerID={selectedCustomerID}
                setSelectedCustomerID={setSelectedCustomerID}
                filteredCustomerList={filteredCustomerList}
                selectedProblemType={selectedProblemType}
                setSelectedProblemType={setSelectedProblemType}
                problemList={problemList}
                selectedProblemStatus={selectedProblemStatus}
                setSelectedProblemStatus={setSelectedProblemStatus}
                selectedSeller={selectedSeller}
                setSelectedSeller={setSelectedSeller}
                filteredSellerList={filteredSellerList}
              />
            </DropdownByIcon>
          )
        }
      </ControlSearchPannelLayout>
      {/* <SignatureCanvas 
        width={300} 
        height={150}
        penWidth={1}
        onSignatureChange={handleSignatureChange}
        onSignatureStart={handleSignatureStart}
        onSignatureEnd={handleSignatureEnd}
      />
       */}
      {
        isLoadingProblems ? (
          <CustomBlockLoader />
        ) : (
          <BodyScrollContainer>
            <TitlesList 
              list={filteredProblems}
              uniqueKey='RecID'
              Element={ProblemWithDetailsItem}
              additionalData={additionalItemProps}
            />
          </BodyScrollContainer>
        )
      }
      <ControlButton 
        lable={'חדש'}
        handleClick={handleCreate}
      />
    </OrderlikeLayout>
  )
}

export default ProblemTeudotMain